import Alert from 'reactstrap/lib/Alert';
import queryString from 'query-string';

import Card from 'Lib/components/common/Card';
import Page from 'Lib/components/common/page-layout/index';
import PhoneField from 'Lib/components/form/PhoneField';
import { default as PublicApplication } from 'Lib/components/screening/application/Application';

// Style Imports
import '~/scss/layout/_default.scss';
import 'Lib/scss/components/_application.scss';
import 'Lib/scss/components/_fileManager.scss';
import 'Lib/scss/components/_upload.scss';
import 'Lib/scss/components/_uploadFiles.scss';

import { uploadFile } from '~/api/files';
import {
    createApplicationGroup,
    createStartedApplication,
    fetchIdentityVerificationToken,
    fetchIncomeVerificationToken,
    getApplicationGroup,
    getGenericApplication,
    getStartedApplication,
    getSubmittedTemplate,
    getUnitForApplication,
    saveApplication,
    setIncomeVerificationToken,
    updateStartedApplication
} from '~/api/screening';
import CountryField from '~/components/form/CountryField';
import StateField from '~/components/form/StateField';
import UnitField from '~/components/form/UnitField';
import withContainer from '~/components/hoc/withContainer';
import Listings from '~/components/listings/Listings';

function Application(props) {
    // const { preview, templateID: previewTemplateID } = queryString.parse(props.router.location.search);


    // TODO - restore redirect after successful prod deployment. We don't want to redirect to applicant portal 
    // until we've verified portal is accessible. 
    // =====================================

    const {
        app: {
            account: { subdomain },
            domain
        },
        route: {
            location: { search }
        }
    } = props;

    const url = `https://${subdomain}${domain}/portals/applicant/apply${search}`;

    // Use window.replace instead of react-router history because we need to route to 
    // absolute URL because public portal will force routing under /public path 
    // for all relative routing 
    // e.g. history.replace('/portals/applicant/apply') resolves to '/public/portals/applicant/apply'
    window.location.replace(url);

    return;

    // =====================================

    // if (props.app.screeningSettings?.isApplicationEnabled == '0' && !previewTemplateID) {
    //     return (
    //         <Page title="Application" hideBreadcrumbs>
    //             {() => <Card style={{ textAlign: 'center' }}>The Property Manager currently has disabled the submission of Applications.</Card>}
    //         </Page>
    //     );
    // }

    // return (
    //     <>
    //         {preview && <Alert color="warning">You are currently previewing an application and are unable to submit</Alert>}
    //         <PublicApplication
    //             {...props}
    //             steps
    //             components={{
    //                 Page,
    //                 Listings,
    //                 PhoneField,
    //                 CountryField,
    //                 StateField,
    //                 UnitField
    //             }}
    //             endpoints={{
    //                 createApplicationGroup,
    //                 getBuilder: getSubmittedTemplate,
    //                 getGenericApplication,
    //                 getApplicationGroup,
    //                 fetchUnit: getUnitForApplication,
    //                 submitApplication: saveApplication,
    //                 uploadFile,
    //                 getStartedApplication,
    //                 createStartedApplication,
    //                 updateStartedApplication,
    //                 fetchIncomeVerificationToken,
    //                 setIncomeVerificationToken,
    //                 fetchIdentityVerificationToken
    //             }}
    //             publicApp
    //         />
    //     </>
    // );
}

export default withContainer(Application);
